function initFormField(field) {
  // console.log(field);
  const input = field.querySelector('input');
  input.addEventListener('focus', e => {
    field.classList.add('focus');
  });
  input.addEventListener('blur', e => {
    if (!e.target.value) {
      field.classList.remove('focus');
    }
  });
}

export default initFormField;